<template>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalCreateLivraison'" ref="modalLivraisonRef"@save="saveLivraison">
        <div class="form">
            <div class="form-group">
                <label for="livraison_libelle">Date de livraison</label>
                <input type="Date" class="form-control" id="livraison_libelle" v-model="livraison.dateLivraison" />
            </div>
        </div>
    </ModalEdition>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
    name: 'livraisonCreate',
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            livraison: {
                dateLivraison : null
            },
            errors: [],
        }
    },
    methods: {
        saveLivraison() {
            this.errors = []
            Axios.post('/livraison', this.livraison)
                .then(() => {
                    this.$refs.modalLivraisonRef.closeModal();
                    this.$emit('saved');
                }).catch(err => {
                    console.error('Erreur lors de la sauvegarde de la livraison:', err);
                });
        },
    },
    watch: {
        params: {
            handler(params) {
                if (params.date != null) {
                    this.livraison.dateLivraison = params.date;
                }
            },
            deep: true,
        },
    },
}
</script>

<style>
</style>